import { render, staticRenderFns } from "./PagesFormPage.vue?vue&type=template&id=76ee7486&"
import script from "./PagesFormPage.vue?vue&type=script&lang=js&"
export * from "./PagesFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports